/* eslint-disable no-undef */
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const createFormalQuote = createAsyncThunk(
  'formalQuote/create',
  async ({ recaptchaWidgetId, ...formData }, { rejectWithValue }) => {
    const authenticity_token = Spree.authenticityToken;

    // Only read an explicit widget. Never bare getResponse() — footer newsletter
    // v3 shares the grecaptcha global and made that ambiguous.
    let recaptchaToken = null;
    if (
      recaptchaWidgetId !== undefined &&
      recaptchaWidgetId !== null &&
      typeof grecaptcha !== 'undefined' &&
      typeof grecaptcha.getResponse === 'function'
    ) {
      try {
        recaptchaToken = grecaptcha.getResponse(recaptchaWidgetId);
      } catch (error) {
        return rejectWithValue({
          error: 'Please complete the reCAPTCHA to submit the form',
        });
      }
    }

    try {
      const response = await axios.post('/formal-quote.json', {
        ...formData,
        authenticity_token,
        'g-recaptcha-response': recaptchaToken,
      });

      return response.data;
    } catch (error) {
      if (error.response?.data?.show_checkbox_recaptcha) {
        return rejectWithValue({
          ...error.response.data,
          show_checkbox_recaptcha: true
        });
      }
      return rejectWithValue(error.response?.data || { error: 'An error occurred' });
    }
  },
);
export { createFormalQuote };
